<template>
  <section id="o-nas" class="about section">
    <div class="container">
      <div class="section-header" data-aos="fade-up">
        <h2>O nas</h2>
        <div class="section-line"></div>
      </div>
      
      <div class="about-content">
        <div class="about-text" data-aos="fade-right">
          <p>
           Firma Vi-Gas jest rodzinną firmą z ponad dwudziestoletnim doświadczeniem w zakresie serwisu urzadzeń grzewczych firmy Viessman. Dzięki ciągłemu rozwojowi w swojej ofercie mamy również instalacje wielokotłowe jak również automatykę wspomagającą efektywną pracę urzadzeń grzewczych.
          </p>
          <p>
            Zajmujemy się instalowaniem i naprawą pieców gazowych i akcesoryjnych urządzeń firmy Viessmann. W naszej ofercie znajdują się usługi pomocy doboru odpowiedniego sprzętu dla dużych bydunków, domów i mieszkań.
          </p>
          <p>
            Realizujemy naprawy gwarancyjne jak i pogwarancyjne, uruchomienia kotłów przemysłowych oraz domowych.
            Zapraszamy do współpracy.
          </p>
          
          <div class="stats">
            <div class="stat-item">
              
              <p>Ponad 20 lat doświadczenia</p>
            </div>
            <div class="stat-item">
            
              <p>Tysiące zadowolonych klientów</p>
            </div>
            <div class="stat-item">
              <p>Szybka pomoc telefoniczna w przypadku awarii</p>
            </div>
          </div>
        </div>
        
        <div class="about-image" data-aos="fade-left">
          <div class="image-placeholder">
            <div class="placeholder-content">
              <h3>VI-GAS Team</h3>
              <p>Profesjonalna i pomocna obsługa</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AboutSection'
}
</script>

<style lang="scss" scoped>
.about {
  background: #f8f9fa;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
  
  h2 {
    font-size: 2.5rem;
    color: #333;
    margin-bottom: 15px;
  }
  
  .section-line {
    width: 60px;
    height: 4px;
    background: linear-gradient(135deg, #FF6B35, #FFD93D);
    margin: 0 auto;
    border-radius: 2px;
  }
}

.about-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.about-text {
  p {
    font-size: 1.1rem;
    line-height: 1.8;
    margin-bottom: 20px;
    color: #555;
  }
}

.stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  margin-top: 40px;
}

.stat-item {
  text-align: center;
  
  h3 {
    font-size: 2.5rem;
    color: #FF6B35;
    font-weight: 800;
    margin-bottom: 5px;
  }
  
  p {
    color: #666;
    font-weight: 500;
  }
}

.about-image {
  .image-placeholder {
    width: 100%;
    height: 350px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 15px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    text-align: center;
    
    .placeholder-content {
      h3 {
        font-size: 2rem;
        margin-bottom: 10px;
        color: white;
      }
      
      p {
        font-size: 1.1rem;
        opacity: 0.9;
        color: white;
      }
    }
  }
}

@media (max-width: 768px) {
  .about-content {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  
  .stats {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .section-header h2 {
    font-size: 2rem;
  }
}
</style>